import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CancelIcon from '@material-ui/icons/CancelOutlined';

const styles = theme => ({
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
	},

	pdfDiv: {
		height: 'calc(100% - 180px)',
		zIndex: 1,
		position: 'fixed',
		top: `180px`,
		left: `0px`,
		right: '0px'
	},

	content: {
		backgroundColor: 'white',
		opacity: '1',
	},

});

class ViewCCCheck extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorString: '',
			notifyString: '',
			showPdf: false,
			useUrl: '',
		};
		this.handleClose = this.handleClose.bind(this);
	}

	handleClose(e) {
		e.preventDefault();
		fetch('on_delete_pdf_report',
			{
				method: 'POST',
				credentials: 'same-origin',
				headers:
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						'r': new Date().getTime(),
						'secureToken': this.props.secureToken
					}
				)
			})
			.then(function (res) {
				if (!res.ok) {
					throw Error(res.status + " (" + res.statusText + ")");
				}
				return res;
			}).then(res => res.text())
			.then(text => {
				this.props.onClosePopup(e);
			})
			.catch(error => {
				this.props.onClosePopup(e);
			});
	}

	componentDidMount() {
		this.generateReport();
	}

	generateReport() {
		this.setState({ showPdf: false });
		this.setState({ useUrl: 'on_fetch_pdf_report?report_id=' + new Date().getTime() });
		this.setState({ showPdf: true });
	}

	getUrl() {
		return this.props.pdfUrl;
	}

	render() {
		const { classes } = this.props;
		let { t } = this.props;
		return (
			<div style={{ opacity: '1' }}>
				<Dialog
					open
					fullScreen={true}
					PaperProps={{
						classes: {
							root: classes.content
						}
					}}
				>
					<DialogContent className={classes.pdfDiv}>
						<div id='myPdf' className={classes.pdfDiv}>
							{this.state.showPdf &&
								<embed src={this.state.useUrl} type="application/pdf" style={{ width: '100%', height: '100%' }} />
							}
						</div>
					</DialogContent>
					<DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
						<Button color='primary' onClick={this.handleClose} >
							<CancelIcon />&nbsp;{t('closeCheckImg.button')}
						</Button>
					</DialogActions>

					{this.state.errorString.length > 0 &&
						<p style={{ color: 'red', textAlign: 'center' }}> {'ERROR: ' + this.state.errorString + '. Please close this view (click the above CLOSE PDF VIEW button).'}</p>
					}
					{this.state.notifyString.length > 0 &&
						<p style={{ color: 'primary', textAlign: 'center' }}> {this.state.notifyString + '. Please close this view (click the above CLOSE PDF VIEW button).'}</p>
					}
					<p style={{ color: 'primary', fontSize: 12, textAlign: 'center' }}>{t('printCheck.label')}</p>
				</Dialog>
			</div>
		);
	}
}
export default withTranslation()(withStyles(styles)(ViewCCCheck));
